import styled, { css } from "styled-components";

export const StyledListItem = styled.li`
    width: 100%;
    padding: 16px 0;
    font-size: 14px;
    ${({ theme }) => theme.fonts.mulishLight}
    display: flex;
    justify-content: ${({ justifyContent }) => justifyContent};
    ${({ noBoldLastChild }) => !noBoldLastChild && css`
        & > :last-child {
            ${({ theme }) => theme.fonts.mulishBold};
        }
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;
